import { render, staticRenderFns } from "./SizeChart.vue?vue&type=template&id=5249da63&scoped=true&"
import script from "./SizeChart.vue?vue&type=script&lang=js&"
export * from "./SizeChart.vue?vue&type=script&lang=js&"
import style0 from "./SizeChart.vue?vue&type=style&index=0&id=5249da63&scoped=true&lang=css&"
import style1 from "./SizeChart.vue?vue&type=style&index=1&id=5249da63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249da63",
  null
  
)

export default component.exports